import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { anyEnabledSchedule, userCanEditSchedule } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleDisable } from './ScheduleMenuActions';

export const ScheduleDisableAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.DisableSchedules,
  translateName: Messages.disable_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyEnabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleDisable(targetItems)
};
